import { CorrespondenceDocuments } from 'api';

export const getCorrespondenceDocumentFilename = (
  document: CorrespondenceDocuments,
): string | null => {
  if (document.report) return document.report.filename || '';
  if (document.document) {
    return (document.document.file_name || '').replace(/[a-zA-Z0-9]+_/, '');
  }
  return null;
};
